import { render, staticRenderFns } from "./ActivityView.vue?vue&type=template&id=1d044224&scoped=true&"
import script from "./ActivityView.vue?vue&type=script&lang=js&"
export * from "./ActivityView.vue?vue&type=script&lang=js&"
import style0 from "./ActivityView.vue?vue&type=style&index=0&id=1d044224&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d044224",
  null
  
)

export default component.exports